module.exports = __webpack_public_path__ + "static/media/window-tinting_icon.a23af780.svg";